// The status of an automatic invoicing setup as people see it; the backend stores it as IsActive.
const InvoiceAutomationStatusEnum = {
  Active: 'Active',
  Deactivated: 'Deactivated',
};

export default InvoiceAutomationStatusEnum;
